module.exports = "/fast-coin/img/coin/anim/shine_2/shine_2_026.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_2/shine_2_026.png
// module id = 2373
// module chunks = 5